import { getPrometheusMetrics } from '@upshow/brightsign/src';
import { getDeviceInfo } from '../Upshow';
import SocketService from './SocketService';

class PrometheusService {
    _timer = null;
    _currentInterval = null;

    sync(intervalSeconds) {
        const interval = intervalSeconds && Number(intervalSeconds) > 0 ? Number(intervalSeconds) : null;

        if (interval === this._currentInterval) return;

        this._stop();

        if (!interval) {
            console.log('[PrometheusService] stopped');
            return;
        }

        this._currentInterval = interval;
        console.log(`[PrometheusService] starting, interval: ${interval}s`);
        this._timer = setInterval(async () => {
            if (!SocketService.socket?.connected) {
                console.log('[PrometheusService] socket not connected, skipping tick');
                return;
            }
            const metrics = await getPrometheusMetrics();
            if (!metrics) {
                console.log('[PrometheusService] no metrics received');
                return;
            }
            const { serial } = getDeviceInfo();
            console.log(`[PrometheusService] emitting metrics for device: ${serial}`);
            SocketService.socket.emit('prometheus-metrics', { metrics, deviceId: serial });
        }, interval * 1000);
    }

    _stop() {
        if (this._timer) {
            clearInterval(this._timer);
            this._timer = null;
        }
        this._currentInterval = null;
    }
}

export default new PrometheusService();
